module.exports = __webpack_public_path__ + "img/IMG_1378-2.bba0c6a3.png";